module.exports = __webpack_public_path__ + "img/Jump Casting126.95b2068a.jpg";